/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const ClockIcon = ({
  className,
  style,
  color = '#ADA9BB',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.5 0C2.90927 0 0 2.90927 0 6.5C0 10.0907 2.90927 13 6.5 13C10.0907 13 13 10.0907 13 6.5C13 2.90927 10.0907 0 6.5 0ZM12.1613 6.5C12.1613 9.61109 9.64254 12.1613 6.5 12.1613C3.38891 12.1613 0.83871 9.64254 0.83871 6.5C0.83871 3.38891 3.35746 0.83871 6.5 0.83871C9.61109 0.83871 12.1613 3.35746 12.1613 6.5ZM8.25867 8.81431L6.13044 7.26794C6.04919 7.20766 6.00202 7.11331 6.00202 7.01371V2.83065C6.00202 2.65766 6.14355 2.51613 6.31653 2.51613H6.68347C6.85645 2.51613 6.99798 2.65766 6.99798 2.83065V6.66512L8.84577 8.00968C8.9873 8.11189 9.01613 8.30847 8.91391 8.45L8.69899 8.74617C8.59677 8.88508 8.4002 8.91653 8.25867 8.81431Z"
        fill={color}
      />
    </svg>
  );
};
